import { Component, OnInit } from '@angular/core';
import { Socifact } from 'src/app/entity/Facture';
import { environment } from 'src/environments/environment';
import { AdminService } from 'src/app/service/admin.service';
import saveAs from 'save-as'
@Component({
  selector: 'app-societe',
  templateUrl: './societe.component.html' 
})
export class SocieteComponent implements OnInit {
  uploadUrl: String = environment.restApiCRM+'mails/upload1';
  loading
  selectedSocifact: Socifact;
  socifact: Socifact[]
  cols:any;
  designationPjoint: any;
  isEdit:boolean
  constructor(private adminService: AdminService) { }

  ngOnInit() {
    this.cols = [

      { field: 'nom', header: 'Nom' }
    ];
    this.findAllSocifact()
  }
  uploadedFiles: any[] = [];
  file: File;
  openFile(blob: any) {

  //  saveAs(blob, blob.name)
  }
  removePJ(file: File) {
    let filesTemp: any[] = [];
    this.uploadedFiles.forEach(element => {
      if (element !== file)
        filesTemp.push(element);
    });
    this.uploadedFiles = filesTemp;
  }
 formatBytes(a, b) { if (0 == a) return "0 Bytes"; var c = 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], f = Math.floor(Math.log(a) / Math.log(c)); return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f] }

  onUpload1(event) {

    for (let file of event.files) {

      this.uploadedFiles.push(file);
    }
  }
  findAllSocifact() {
    this.adminService.findAllSocifact().subscribe(result => {
      this.socifact = result
      this.socifact.forEach(element => {
 
        
        if(this.selectedSocifact && this.selectedSocifact.sociFactId==element.sociFactId)
     this.selectedSocifact=element
        
      });
    })
  }


  createSocifact() {
    let socifact: Socifact = new Socifact()
 
    socifact.designation = "new Model"
    this.adminService.createSocifact(socifact).subscribe(result => {
      this.findAllSocifact()
    })
  }

  save() {

    this.adminService.saveSocifact(this.selectedSocifact).subscribe(result => {

    })
  }

  removeSocifact() {
    this.adminService.removeSocifact(this.selectedSocifact).subscribe(result => {
      let resSTR = JSON.stringify(result);
      let resJSON = JSON.parse(resSTR);
  
this.findAllSocifact()
    },error=>
 ( alert(error) ))

  }
  

  selectedProject: String[];
 

  uploadFunction(event) {
    this.uploadedFiles=[];
    for (let file of event.files) {

      this.designationPjoint = file.name;
      this.uploadedFiles.push(file);

    }
  }
  src:Blob;
  showTete(sociFact:Socifact){
    //console.log('resultresul');
    
    this.adminService.showFile( sociFact).subscribe(result=>{
      this.src=result;
      //console.log("resultresultresultresult"+result);
      
      saveAs(result, result.name)
    });
  }
  saveFile(type:string) {
    let fd = new FormData();
    for (let file of this.uploadedFiles) {
      if (this.designationPjoint)

        fd.append("file", file, this.designationPjoint);
      this.designationPjoint = ""

    }
    this.adminService.uploadFile(fd,type+this.selectedSocifact.sociFactId+".png",this.selectedSocifact.sociFactId).subscribe(result => {
     this.findAllSocifact()
   //   this.findAllPjoints();
    });
  }
  public CkeditorConfig1 = {
    allowedContent: true,
    extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};span(*);i(*);',
    CKEDITOR: [{dtd: {$removeEmpty: {i: 0} } } ],
    height: 400,
    toolbarGroups: [ ]
  }
}
